type GetNavigationStartTimestamp = () => number | undefined;
export const getNavigationStartTimestamp: GetNavigationStartTimestamp = () => {
  if (window.performance.timeOrigin) {
    return Math.round(window.performance.timeOrigin);
  }

  // Required till `performance.timeOrigin` is supported in IE, Safari and Safari on iOS.
  const timing = window.performance.timing;

  return timing && timing.navigationStart;
};
